export const btpPaths = {
  chantiers: "/api/v1/btp/chantiers/",
  chantier: (id: number | string) => `/api/v1/btp/chantiers/${id}/`,
  overview: (id: number | string) => `/api/v1/btp/chantiers/${id}/overview/`,
  lots: "/api/v1/btp/lots/",
  bordereau: "/api/v1/btp/bordereau/",
  rapports: "/api/v1/btp/rapports/",
  situations: "/api/v1/btp/situations/",
  lignesSituation: "/api/v1/btp/lignes-situation/",
  sousTraitances: "/api/v1/btp/sous-traitances/",
  consommations: "/api/v1/btp/consommations/",
};
